/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var DepIrregularityEditView = require('../views/DepIrregularityEditView');

var GetIrregularity = require('../services/GetIrregularity');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetIrregularityLookups = require('../services/GetIrregularityLookups');

module.exports = function(entityId, irregularityId) {
  NProgress.start();
  NProgress.set(0.4);
  $.when(GetIrregularity(irregularityId), GetEntityIdentifiers(entityId))
    .done(function(irregularity, entityIdentifiers) {
      NProgress.set(0.7);
      GetIrregularityLookups(entityIdentifiers.categoryId)
        .done(function(lookups) {
          NavUtils.navigate('#dep/entity/' + entityId + '/irregularity/' + irregularityId + '/edit');
          Scaffold.content.show(
            new DepIrregularityEditView({
              viewMode: 'int',
              model: new Backbone.Model({
                entityId: entityId,
                irregularityId: irregularityId,
                entityIdentifiers: entityIdentifiers,
                irregularityCategories: lookups.categoryList,
                irregularitySubcategories: lookups.subcategoryList,
                irregularity: irregularity
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
